import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "space-y-4 p-4 sm:p-6 lg:p-8"
}
const _hoisted_2 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "flex items-center space-x-4" }
const _hoisted_4 = { class: "space-y-4" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" }
const _hoisted_6 = { class: "mb-1 font-semibold" }
const _hoisted_7 = { class: "mb-1 font-semibold" }

import { ref, type Ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import { useUiStore } from '@/stores';
import { WordService } from '@/services';
import { toastServiceError } from '@/services/core/notification';
import { type WordModel, Permission } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'WordDetailPage',
  setup(__props) {

const route = useRoute();

const uiStore = useUiStore();

const word: Ref<WordModel | undefined> = ref(undefined);

const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const fetchWord = async (id: number) => {
    setLoading(true);
    try {
        const response = await WordService.get<WordModel>(id);
        word.value = response.data;
    } catch (error) {
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

onMounted(() => {
    fetchWord(Number(route.params.id));
});

return (_ctx: any,_cache: any) => {
  const _component_UiBackButton = _resolveComponent("UiBackButton")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiAuditStatusInfo = _resolveComponent("UiAuditStatusInfo")!
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (word.value !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_UiPageHeader, null, {
          info: _withCtx(() => [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('word.view.title')), 1)
          ]),
          actions: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_UiBackButton, { fallbackTo: { name: 'ListWord' } }),
              (_ctx.$can(_unref(Permission).EDIT_WORD))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {
                            name: 'EditWordById',
                            params: {
                                id: word.value?.id,
                            },
                        },
                    class: "block hover:bg-gray-50"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UiButton, {
                        variant: "primary",
                        "text-variant": "white"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Edit')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_UiPanel, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('word.labels.word')), 1),
                  _createElementVNode("p", null, _toDisplayString(word.value.word), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('word.labels.callParticipant')), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t(`word.participant.${word.value.callParticipant}`)), 1)
                ])
              ]),
              _createVNode(_component_UiAuditStatusInfo, {
                "model-value": word.value,
                class: "bt-1 mt-4 border-t border-gray-300 pt-2"
              }, null, 8, ["model-value"])
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})